import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  Typography,
  Button,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { saveAs } from 'file-saver';
import moment from 'moment';
import SelectTenant from '../../components/Select/SelectTenant';
import { setSelectTenant } from '../../utils/common';
import CalendarDateRange from './components/DatePicker/CalendarDateRange';
import ContentRow from './components/Table/ContentRow';
import { getToken } from '../../components/Token';
import { getTenantHeaders } from '../../components/TenantHeaders';
import config from '../../config';

class DeviceUsageSummary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      tenant: '',
    };
  }

  async componentDidMount() {
    this.props.device.resetData();
    const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
    this.setState({
      tenant: tenantIds ? JSON.stringify(tenantIds) : '',
    });
    const { startDate, endDate } = this.state;
    const startDateFormate = `${startDate.getFullYear()}-${('0' + (startDate.getMonth() + 1)).slice(
      -2,
    )}-${('0' + startDate.getDate()).slice(-2)}`;
    const endDateFormate = `${endDate.getFullYear()}-${('0' + (endDate.getMonth() + 1)).slice(
      -2,
    )}-${('0' + endDate.getDate()).slice(-2)}`;

    if (tenantIds && tenantIds.length > 0) {
      await this.props.device.getUsageSummary(startDateFormate, endDateFormate, tenantIds[0]);
      await this.props.device.getDevices(['NEW'], 0, 0, null, null, null, tenantIds, true);
    }
  }

  onSubmit = async () => {
    const { t } = this.props;
    const { startDate, endDate, tenant } = this.state;
    const startDateTime = moment(new Date(`${startDate}`))
      .toDate()
      .getTime();
    const endDateTime = moment(new Date(`${endDate}`))
      .toDate()
      .getTime();

    if (startDateTime > endDateTime) {
      Swal.fire({
        html: `<h4>${t('invalid_format')}`,
        type: 'warning',
      });
    } else {
      const startDateFormate = `${startDate.getFullYear()}-${('0' + (startDate.getMonth() + 1)).slice(
        -2,
      )}-${('0' + startDate.getDate()).slice(-2)}`;
      const endDateFormate = `${endDate.getFullYear()}-${('0' + (endDate.getMonth() + 1)).slice(
        -2,
      )}-${('0' + endDate.getDate()).slice(-2)}`;
      const tenantIds = tenant ? JSON.parse(tenant) : null;
      try {
        if (tenantIds && tenantIds.length > 0) {
          await this.props.device.getUsageSummary(startDateFormate, endDateFormate, tenantIds[0]);
          await this.props.device.getDevices(['NEW'], 0, 0, null, null, null, tenantIds, true);
        }
      } catch (error) {
        console.log('error: ', error);
      }
    }
  };

  onStartDateChange = (date) => {
    this.setState({ startDate: date });
  };

  onEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  titleContent() {
    const { classes, t } = this.props;
    const { startDate, endDate } = this.state;

    return (
      <div className={classes.titleBar}>
        {/* <SelectTenant
          handleChangeTenant={this.handleChangeTenant}
          tenant={this.state.tenant}
          allTenantsHiding={true}
        /> */}
        <Grid className={classes.wrapCalendar}>
          <CalendarDateRange
            startDateLable={t('start_date')}
            endDateLable={t('end_date')}
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={this.onStartDateChange}
            onEndDateChange={this.onEndDateChange}
          />
          <Button
            color='primary'
            variant='contained'
            style={{
              height: 38,
              width: 95,
              boxShadow: 'none',
            }}
            className={classes.wrapButton}
            onClick={() => this.onSubmit()}
            disabled={this.state.tenant ? false : true}
          >
            {t('apply')}
          </Button>
        </Grid>
      </div>
    );
  }

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    const tenantIds = JSON.parse(value);
    setSelectTenant(tenantIds);
  };

  handleDownloadCSV() {
    const { classes } = this.props;
    return (
      <div className={classes.wrapBtncsv}>
        <Button
          variant='outlined'
          color='primary'
          className={classes.btncsv}
          id='download'
          onClick={this.onSubmitExportCSV}
        >
          <Icons.GetApp />
          CSV
        </Button>
      </div>
    );
  }

  onSubmitDownloadCSV = async () => {
    await this.props.device.getUsageSummaryCSV();
  };

  onSubmitExportCSV = () => {
    const tenantId = 1;
    const startDate = '2022-11-13';
    const endDate = '2022-11-14';

    const params = new URLSearchParams({ tenantId, startDate, endDate });

    let url = `${config.api.url}/${config.api.version}/device/usagesummary/csv?${params}`;

    console.log(url);
    try {
      fetch(url, {
        method: 'GET',
        headers: {
          ...getTenantHeaders(),
          Authorization: 'Bearer ' + getToken('id_token'),
        },
      })
        .then(function (response) {
          if (response.status === 200) {
            return response.blob();
          } else {
            Swal.fire({
              html: `<h4>ไม่มีข้อมูล`,
              type: 'error',
            });
          }
        })
        .then(function (blob) {
          if (blob) {
            console.log('blob: ', blob);
            saveAs(blob, `usagesummary.zip`);
          }
        });
    } catch (err) {
      Swal.fire({
        html: `<h4>ไม่มีข้อมูล`,
        type: 'error',
      });
    }
  };

  handleToggle = (index) => {
    let { deviceUsageSummary } = this.props.device.toJS();
    (deviceUsageSummary.patients || []).forEach((p, i) => {
      if (i === index) {
        p.toggle = !p.toggle;
      }
    });
    this.props.device.setData('deviceUsageSummary', deviceUsageSummary, false);
  };

  render() {
    const { t, classes } = this.props;
    const { deviceUsageSummary, noActivePatients, noActiveDevcies, devices } = this.props.device.toJS();
    const currentlyAssignedDevcies = (devices.data || []).filter((d) => d.assignTo);

    const tmp = (
      <React.Fragment>
        <div className={classes.pageTitleContainer}>
          <Grid container item xs={12} sm={12} md={12} lg={5} xl={4}>
            <Typography className={classes.headTitle}>{t('device_usage_summary')}</Typography>
            <div className={classes.titleBar}>
              <SelectTenant
                handleChangeTenant={this.handleChangeTenant}
                tenant={this.state.tenant}
                allTenantsHiding={true}
              />
            </div>
          </Grid>
          <Grid item xs={8} sm={8} md={8} lg={5} xl={6}>
            {this.titleContent()}
          </Grid>
          <Grid item xs={2} sm={2} md={4} lg={2} xl={2}>
            {this.handleDownloadCSV()}
          </Grid>
        </div>
        {/* <PageTitle
          title={t("device_usage_summary")}
          button={this.handleDownloadCSV()}
        >
          {this.titleContent()}
        </PageTitle> */}
        <Grid className={classes.mainContain} spacing={32} container>
          <Grid item sm={12}>
            <Paper className={classes.gridContent}>
              <Grid container spacing={24}>
                <Grid container item sm={4}>
                  <div className={classes.bgIcon}>
                    <Icons.Memory className={classes.styleIcon} />
                  </div>
                  <div className={classes.wrapContent}>
                    <Typography className={classes.contentTitle}>{t('currently_assigned')}</Typography>
                    <Typography className={classes.contentSubTitle}>{currentlyAssignedDevcies.length}</Typography>
                  </div>
                </Grid>
                <Grid container item sm={4}>
                  <div className={classes.bgIcon}>
                    <Icons.Memory className={classes.styleIcon} />
                  </div>
                  <div className={classes.wrapContent}>
                    <Typography className={classes.contentTitle}>{t('active_devices')}</Typography>
                    <Typography className={classes.contentSubTitle}>{noActiveDevcies}</Typography>
                  </div>
                </Grid>
                <Grid container item sm={4}>
                  <div className={classes.bgIcon}>
                    <Icons.Person className={classes.styleIcon} />
                  </div>
                  <div className={classes.wrapContent}>
                    <Typography className={classes.contentTitle}>{t('active_patients')}</Typography>
                    <Typography className={classes.contentSubTitle}>{noActivePatients}</Typography>
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} style={{ paddingTop: 4 }}>
            <Paper className={classes.paperList}>
              <Table aria-label='simple table'>
                <TableHead>
                  <TableRow className={classes.headTable}>
                    <CustomTableCell className={classes.tableCell} align='left'>
                      {t('name')}
                    </CustomTableCell>
                    <CustomTableCell className={classes.tableCell} align='left'>
                      {t('wizard_module_no_of_devices')}
                    </CustomTableCell>
                    <CustomTableCell className={classes.tableCell} align='left'>
                      {t('messages')}
                    </CustomTableCell>
                    <CustomTableCell className={classes.tableCell} align='left'>
                      {t('active_days')}
                    </CustomTableCell>
                    <CustomTableCell className={classes.tableCell} align='left'>
                      {t('alerts')}
                    </CustomTableCell>
                    <CustomTableCell className={classes.tableCell} align='left'></CustomTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {deviceUsageSummary && deviceUsageSummary.patients.length > 0 ? (
                    deviceUsageSummary.patients.map((data, index) => (
                      <ContentRow key={index} data={data} index={index} handleToggle={this.handleToggle} />
                    ))
                  ) : (
                    <TableRow>
                      <CustomTableCell colSpan={12}>
                        <Typography component='div' className={classes.noDataBox}>
                          {' '}
                          {t('no_data')}
                        </Typography>
                      </CustomTableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
    return tmp;
  }
}

const CustomTableCell = withStyles((theme) => ({
  head: {
    color: theme.palette.text.header,
    border: 'none',
    fontWeight: 500,
    fontSize: 16,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  body: {
    color: theme.palette.text.header,
    fontSize: 16,
    borderTop: '1px solid #B8CFC3',
    borderBottom: 'none',
    // overflow: "hidden",
    // textOverflow: "ellipsis",
    // whiteSpace: "nowrap",
  },
}))(TableCell);

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  btncsv: {
    border: 'none',
    backgroundColor: '#E5F0F6',
    cursor: 'pointer',
    height: '38px',
    '&:hover': {
      border: 'none',
      backgroundColor: '#E5F0F6',
    },
  },
  wrapBtncsv: {
    marginTop: '5px',
    [theme.breakpoints.up('md')]: {
      textAlign: 'right',
      marginTop: 0,
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  wrapCalendar: {
    display: 'flex',
    // width: "520px",
    marginTop: 6,
  },
  wrapButton: {
    marginLeft: 18,
    marginTop: 4,
    display: 'flex',
  },
  paperList: {
    overflowX: 'auto',
    padding: '10px 20px',
    boxShadow: '0px 4px 34px rgba(0, 0, 0, 0.06)',
  },
  tableCell: {
    color: theme.palette.text.header,
    borderBottom: '1px solid #B8CFC3',
    padding: '4px',
  },
  headTable: {
    border: 'none',
  },
  bodyTable: {
    borderTop: '1px solid #B8CFC3',
  },
  bgIcon: {
    backgroundColor: theme.palette.primary.bg,
    width: 80,
    height: 80,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    margin: 8,
  },
  styleIcon: {
    color: theme.palette.success.main,
    width: 55,
    height: 55,
  },
  gridContent: {
    position: 'relative',
    boxShadow: '0px 4px 34px rgba(0, 0, 0, 0.06)',
    overflow: 'hidden',
    padding: '10px 25px',
  },
  wrapContent: {
    margin: 8,
    textAlign: 'center',
  },
  contentTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  contentSubTitle: {
    fontSize: 36,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  noDataBox: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 600,
    color: theme.palette.text.header,
  },
  pageTitleContainer: {
    background: 'white',
    margin: '-24px',
    padding: '36px 40px 7px 40px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  headTitle: {
    color: theme.palette.text.header,
    fontSize: '24px',
    padding: '4px',
    fontWeight: 500,
    marginRight: 10,
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
  },
  button: {
    boxShadow: theme.customShadows.widget,
    textTransform: 'none',
    '&:active': {
      boxShadow: theme.customShadows.widgetWide,
    },
  },
  // wrapContent: {
  //   display: "flex",
  //   width: "80%",
  //   [theme.breakpoints.down("md")]: {
  //     width: "100%",
  //   },
  // },
  // wrapContentWithOutButton: {
  //   display: "flex",
  //   width: "100%",
  // },
});

export const page = inject('device')(observer(DeviceUsageSummary));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
